import * as React from 'react'

import { ClickAwayListener } from '@mui/material';


type Props = {
    children?: any,
    isEdit?: boolean,
    onChange: (isEdit: boolean) => void;
}


const EditableFilterComponent: React.FC<Props> = ({ isEdit=false, onChange, children }: Props) => {
    const additionalClasses = isEdit ? 'border-viking-700' : ''

    return (
        <ClickAwayListener onClickAway={() => onChange(false)}>
            <div
                className={"text-xs bg-white text-gray-500 border rounded px-2 py-1 hover:border-black hover:bg-gray-100 cursor-pointer " + additionalClasses}
                onClick={() => {
                    onChange(true);
                }}>
                {children}
            </div>
        </ClickAwayListener>
    );
}

export default EditableFilterComponent;



